module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_8.d70dd8ae.png";